export type LogLevel = "info" | "log" | "error";

export type LogCobrancaCategoria =
  | "CARTAO_TENTATIVA"
  | "CARTAO_ERRO"
  | "PIX_ERRO"
  | "PIX_GERADO"
  | "BOLETO_GERADO"
  | "BOLETO_ERRO"
  | "NOTIFICACAO"
  | "INSCRICAO_REMOVIDA"
  | "OUTRO";

export type LogCobrancaStatus = "SUCESSO" | "ERRO" | "INFO" | "AVISO";

export interface ILogCartaoCustomer {
  name: string;
  cpf: string;
  email: string;
  phone: string;
}

export interface ILogCartaoEntry {
  id: string;
  timestamp: string;
  level: LogLevel;
  categoria: LogCobrancaCategoria;
  status: LogCobrancaStatus;
  message: string;
  detail: string | null;
  numeroInscricao: string | null;
  totalInscricao: number | null;
  installments: number | null;
  customer: ILogCartaoCustomer | null;
  erroCodigo: string | null;
  formaPagamento: "CARTAO" | "BOLETO" | "PIX" | null;
}

export interface ILogsCartaoResumo {
  total: number;
  cartaoTentativas: number;
  cartaoErros: number;
  notificacoes: number;
  boletos: number;
  pixGerados?: number;
}

export interface ILogsCartaoResponse {
  data: ILogCartaoEntry[];
  raw: string;
  resumo: ILogsCartaoResumo;
}

export interface ILogsCartaoFilters {
  numeroInscricao: string;
  nomeCliente: string;
  cpf: string;
  categoria: LogCobrancaCategoria | "";
  status: LogCobrancaStatus | "";
}

export const DEFAULT_LOGS_CARTAO_FILTERS: ILogsCartaoFilters = {
  numeroInscricao: "",
  nomeCliente: "",
  cpf: "",
  categoria: "",
  status: "",
};

export const CATEGORIA_LABELS: Record<LogCobrancaCategoria, string> = {
  CARTAO_TENTATIVA: "Cartão — tentativa",
  CARTAO_ERRO: "Cartão — erro",
  PIX_ERRO: "PIX — erro",
  PIX_GERADO: "PIX gerado",
  BOLETO_GERADO: "Boleto gerado",
  BOLETO_ERRO: "Boleto — erro",
  NOTIFICACAO: "Notificação",
  INSCRICAO_REMOVIDA: "Inscrição removida",
  OUTRO: "Outro",
};

export const STATUS_LABELS: Record<LogCobrancaStatus, string> = {
  SUCESSO: "Sucesso",
  ERRO: "Erro",
  INFO: "Info",
  AVISO: "Aviso",
};

export const STATUS_FILTER_OPTIONS: {
  value: LogCobrancaStatus | "";
  label: string;
}[] = [
  { value: "", label: "Todos" },
  { value: "SUCESSO", label: "Sucesso" },
  { value: "ERRO", label: "Erro" },
  { value: "INFO", label: "Info" },
  { value: "AVISO", label: "Aviso" },
];
